// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-content {
  display: flex;
  flex: 1 1;
}

.main-content {
  flex: 1 1;
  padding: 24px;
  background: var(--bg);
  overflow-y: auto;
  margin-left: var(--sidebar-width);
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.layout-content.collapsed .main-content {
  margin-left: var(--sidebar-collapsed);
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  gap: 16px;
  font-size: 16px;
  color: var(--text-muted);
}

.sidebar-overlay {
  display: none;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: 16px;
  }
  .layout-content.collapsed .main-content {
    margin-left: 0;
  }
  
  .sidebar-overlay {
    display: block;
    position: fixed;
    top: var(--header-height);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.5);
    backdrop-filter: blur(2px);
    z-index: 90;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  
  .sidebar-overlay.show {
    opacity: 1;
    visibility: visible;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Layout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,yDAAyD;AAC3D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,mDAAmD;EACrD;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.layout-content {\n  display: flex;\n  flex: 1;\n}\n\n.main-content {\n  flex: 1;\n  padding: 24px;\n  background: var(--bg);\n  overflow-y: auto;\n  margin-left: var(--sidebar-width);\n  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.layout-content.collapsed .main-content {\n  margin-left: var(--sidebar-collapsed);\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  gap: 16px;\n  font-size: 16px;\n  color: var(--text-muted);\n}\n\n.sidebar-overlay {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n    padding: 16px;\n  }\n  .layout-content.collapsed .main-content {\n    margin-left: 0;\n  }\n  \n  .sidebar-overlay {\n    display: block;\n    position: fixed;\n    top: var(--header-height);\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.5);\n    backdrop-filter: blur(2px);\n    z-index: 90;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n  }\n  \n  .sidebar-overlay.show {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
